export default "__VITE_ASSET__BsFWybS5__"